// extracted by mini-css-extract-plugin
module.exports = {"geoTab":"geo_geoTab__gcetZ","form":"geo_form__oFCgk","indicatorContainer":"geo_indicatorContainer__Hh_a0","infoIcon":"geo_infoIcon__zD3_I","tooltip":"geo_tooltip__4FWl5"};